export interface Tariff_Floor_Interface {
    id:number,
    price:number,
    persianDate:String,
    username:String,

  }
  
  export function Empty_Tariff_Floor_Interface():Tariff_Floor_Interface{
    return{
      id:0,
      price:0,

      username:'',
      persianDate:'',

    }
  }
  